import { Divider } from '@mui/material'

import { form } from '../../formState'
import * as Texts from '../../intl'
import type { ExecutionEventsFormValues, FormProps } from '../../typings'
import { useTexts } from './useTexts'

import { DynamicLoadsField } from './components/DynamicLoadsField'

export function DynamicLoads(props: FormProps) {
  const { initialValues } = props
  const hasDynamicLoads = Object.keys(initialValues?.dynamicLoads || {}).length > 0

  const texts = useTexts()

  form.useAddFieldValidation('dynamicLoads', (field, _formApi) => {
    const value = field.value

    const errors = Object.entries(value ?? {}).reduce<Record<string, string>>(
      (acc, [key, value]) => {
        if (value.disabled) return acc
        if (typeof value.value !== 'number' || value.value < 0) {
          acc[key] = Texts.getInvalidLoadValueText()
        }
        return acc
      },
      {},
    )

    // Return the first error found
    const firstErrorKey = Object.keys(errors)[0]
    return firstErrorKey ? errors[firstErrorKey] : undefined
  })

  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">{texts.title}</form.SectionTitle>
      {hasDynamicLoads && (
        <>
          <DynamicLoadsField<'dynamicLoads', ExecutionEventsFormValues> name="dynamicLoads" />
          <Divider />
        </>
      )}
    </form.Fieldset>
  )
}
